/* External */
import React from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import Icon from '@dtvgo/icon';

/* Styles */
import './FowardTimeButton.scss';
// import { useIntl } from 'react-intl';
import PlayerButton from '../PlayerButton/PlayerButton';

function FowardTimeButton({
  showButton = true,
  handleRewind,
  tooltip = '',
  className = '',
}) {
  // const { formatMessage } = useIntl();

  if (showButton) {
    return (
      <PlayerButton
        className={`dtv-common-c-fowardtime-button ${className}`}
        onClick={handleRewind}
        tooltip={tooltip}

      >
        <div className="dtv-fowardtime-content-button">
          <Icon name="forward10" />
          {/* <div className="dtv-fowardtime-tooltip">
            {formatMessage({ id: 'player.foward30' })}
          </div> */}
        </div>
      </PlayerButton>
    );
  }

  // eslint-disable-next-line unicorn/no-null -- React doesn't support returning undefined
  return null;
}

FowardTimeButton.propTypes = {
  showButton: true,
  handleRewind: PropTypes.func,
  tooltip: PropTypes.string,
  className: PropTypes.string,
};

FowardTimeButton.defaultProps = {
  showButton: PropTypes.bool,
  handleRewind: () => {},
  tooltip: '',
  className: '',
};
export default FowardTimeButton;
